import {
  PhoneAlert,
  PersonDetails,
  CallPopHeadOfHousehold,
  LocationDetails,
} from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-call/v1/call_pops.pb';

export type PhoneEventPayload = {
  id: string;
  method: 'PhoneSystemEventsLegacy';
  params: {
    PersonID: string;
    gender: string;
    birthdate: number;
    caller_id_name: string;
    caller_id_number: string;
    employee: string;
    event: 'outbound_call' | 'inbound_call' | 'hangup_call' | 'answer_call';
    first_name: string;
    household_id: string;
    household_name: string;
    last_name: string;
    location_id: string;
    phone_number: string;
    queue: string;
    uuid: string;
    version: string;
    workstation: string;
    transferred_by_name: string;
    transferred_by_number: string;
    recipient_location_id: string;
    recipient_location_name: string;
    client_location_name: string;
    client_location_id: string;
    data_source_name: string;
    department_id: string;
    weave_household_id: string;
  };
};

type CamelToSnake<T extends string, P extends string = ''> = string extends T
  ? string
  : T extends `${infer C0}${infer R}`
  ? CamelToSnake<R, `${P}${C0 extends Lowercase<C0> ? '' : '_'}${Lowercase<C0>}`>
  : P;

type CamelKeysToSnake<T> = {
  [K in keyof T as CamelToSnake<Extract<K, string>>]: T[K];
};

/**
 * The `google.protobuf.Timestamp birthdate` field did not translate correctly to TypeScript.
 * So we're manually defining the type here
 */
export type ContactMatch = CamelKeysToSnake<
  Omit<PersonDetails, 'birthdate' | 'weaveLocationsMatched'> & {
    birthdate: { seconds: number };
    weaveLocationsMatched: CamelKeysToSnake<LocationDetails>[];
  }
>;

export type PhoneEventV2Payload = {
  id: string;
  method: 'PhoneSystemEventsV2';
  params: CamelKeysToSnake<
    Required<
      Omit<PhoneAlert, 'callPopHeadOfHousehold' | 'contactMatches'> & {
        callPopHeadOfHousehold: CamelKeysToSnake<Required<CallPopHeadOfHousehold>>;
        contactMatches: Required<ContactMatch>[];
      }
    >
  >;
};

export type PhoneCallQueueEventPayload = {
  id: string;
  method: 'PhoneCallQueueEvents';
  params: {
    queue_id: string;
    call_count: number;
    average_wait_time_in_seconds: number;
    wait_times_in_seconds: number[];
  };
};

export const isPhoneEventV2Payload = (
  payload: PhoneEventPayload | PhoneEventV2Payload
): payload is PhoneEventV2Payload => payload.method === 'PhoneSystemEventsV2';

export const isPhoneEventLegacyPayload = (
  payload: PhoneEventPayload | PhoneEventV2Payload
): payload is PhoneEventPayload => payload.method === 'PhoneSystemEventsLegacy';

export const getHeadofHousehold = (contacts: ContactMatch[]): ContactMatch => {
  return contacts.find((contact) => contact.household_id === contact.patient_id) || contacts[0];
};
